import PropTypes from 'prop-types';
import React from 'react';
/*
{"priceToBreak (long)":100.0,"priceToBreak (short)":99.0,"candleDuration":1.0}
 */
export const CandleTriggerWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'CANDLE_TRIGGER',
    category: 'Setup',
    type: 'Candle Trigger',
    domain: 'Underlying',
  };
  const priceToBreakLong = softOrder['priceToBreak (long)'];
  const priceToBreakShort = softOrder['priceToBreak (short)'];
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;
  const breakBy = softOrder.breakBy;
  const isBreakTrigger = softOrder['isBreakTrigger'];
  const isBreakLongTrigger = softOrder['isBreakLongTrigger'];
  const isBreakShortTrigger = softOrder['isBreakShortTrigger'];

  return (
    <Component
      details={details}
      priceToBreak={priceToBreak}
      candleDuration={candleDuration}
      priceToBreakShort={priceToBreakShort}
      priceToBreakLong={priceToBreakLong}
      breakBy={breakBy}
      isBreakTrigger={isBreakTrigger}
      isBreakLongTrigger={isBreakLongTrigger}
      isBreakShortTrigger={isBreakShortTrigger}
      {...rest}
    />
  );
};

CandleTriggerWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    breakBy: PropTypes.any,
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any,
  }),
};
